<template>
  <el-config-provider :size="'default'">
    <router-view />
  </el-config-provider>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  background: var(--bg-page);
}
</style>
